<template>
  <div class="page-max-width footer-max-width">
    <QHeader class="bg-primary text-white">
      <QToolbar>
        <QBtn
          flat
          round
          dense
          icon="icon-f-arrow-left"
          @click="onGoBack"
        />
        <QToolbarTitle>
          {{ $t('ETAB.PAGES.CGU.@TITLE') }}
        </QToolbarTitle>
      </QToolbar>
    </QHeader>

    <QPageContainer>
      <QPage padding>
        <CGU />
      </QPage>
    </QPageContainer>

    <QFooter class="bg-transparent footer-padding full-width row wrap justify-center q-py-sm">
      <QBtn
        color="secondary"
        class="full-width btn-navigation semi-transparent-bottom-shadow"
        :label="$t('ETAB.PAGES.CGU.@BACK')"
        no-caps
        @click="onGoBack"
      />
    </QFooter>
  </div>
</template>

<script>
import { StatusBar } from "@core/plugins/mobile";
import { ETAB_ROUTES } from "@etab/config";

import CGU from "@core/components/legal/Cgu.component.vue";

export default {
  components: {
    CGU,
  },
  created() {
    StatusBar.setPrimaryBackground();
  },
  beforeUnmount() {
    StatusBar.setDefault();
  },
  methods: {
    onGoBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: ETAB_ROUTES.userMenu.root.name }).catch(suppressedError => {});
      }
    },
  },
};
</script>
